import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { addEvent, removeEvent } from '../../../utils/dom';
import s from './FakeSelect.scss';

class FakeSelect extends Component {
	static defaultProps = {
		selectionHandler: () => {},
	}

	static getDerivedStateFromProps(props) {
		let selected = false;

		props.items.forEach((item) => {
			if (item.selected) selected = item.value;
		});

		return {
			chosenTitle: selected,
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			selectOpen: props.open !== undefined ? props.open : false,
			chosenTitle: false,
		};

		this.fakeSelect = React.createRef();
	}

	componentDidMount() {
		addEvent(document.querySelector('body'), 'click.fakeSelectClose', (e) => {
			if (this.fakeSelect.current && !this.fakeSelect.current.contains(e.target) && this.state.selectOpen) {
				e.stopPropagation();
				e.preventDefault();
				this.setState({
					selectOpen: false,
				});
			}
		});

		addEvent(window, 'keydown.fakeSelectClose', (e) => {
			if (e.key === 'Escape') {
				this.setState({
					selectOpen: false,
				});
			}
		});
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.fakeSelectClose');
		removeEvent(window, 'keydown.fakeSelectClose');
	}

	openSelectHandler = (e) => {
		e.preventDefault();

		this.setState((prevState) => ({
			selectOpen: !prevState.selectOpen,
		}));
	}

	selectedHandler = (e) => {
		e.preventDefault();

		const $input = e.currentTarget;
		const value = $input.value;
		if (this.props.disabled) return;

		this.props.selectionHandler(value, e.target);

		this.setState({
			selectOpen: false,
		});
	}

	render() {
		const { items, title, disabled, adaption, open } = this.props;
		const { selectOpen, chosenTitle } = this.state;

		const selectTitle = chosenTitle || title;

		const fakeSelectClasses = [s.fakeSelect];
		if (selectOpen || open) fakeSelectClasses.push(s.fakeSelect__open);
		if (disabled) fakeSelectClasses.push(s.fakeSelect__disabled);
		if (adaption) fakeSelectClasses.push(s[`fakeSelect__${adaption}`]);

		return (
			<div ref={this.fakeSelect} className={fakeSelectClasses.join(' ')}>
				<a href="#open" onClick={this.openSelectHandler} className={s.fakeSelect_title}>{ selectTitle }</a>
				<div className={s.fakeSelect_inner}>
					{
						items.map((item) => (
							<div key={item.key} className={[s.fakeSelect_inner_item, (item.disabled ? s.fakeSelect_inner_item__disabled : null)].join(' ')}>
								<label htmlFor={item.key}><input id={item.key} className={s.fakeSelect_inner_item_input} onChange={this.selectedHandler} disabled={item.disabled} checked={item.selected} type="radio" name="size" value={item.key} />{ item.value }</label>
							</div>
						))
					}
				</div>
			</div>
		);
	}
}

export default hot(module)(FakeSelect);
